import { Box } from "@mui/material";
import { useIsMobileView } from "../../utils/responsive";
import { ReporteFacturacion } from "../reporteFacturacion/ReporteFacturacion";

export const ReporteFacturacionPage = () => {
  const isMobileView = useIsMobileView();
  return (
    <Box paddingX={isMobileView ? 2 : 10} marginTop={2} paddingBottom={8}>
      <ReporteFacturacion />
    </Box>
  );
};
